<agr-page-detail
  [pageTitle]="pageTitle$ | async"
  data-test="day-old-chick-item__page-detail"
  (backAction)="back()"
>
  <section
    class="day-old-chick-item spacing--padding-all spacing--margin-all"
    data-test="day-old-chick-item"
  >
    <form
      [formGroup]="form"
      [agrConnectForm]="dayOldChickNotNull$"
      (ngSubmit)="save()"
      *ngIf="cycle$ | async as cycle"
    >
      <div class="flex--column">
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'arrival-date' | translate }}</mat-label>
          <input
            matInput
            formControlName="arrivalDate"
            [matDatepicker]="arrivalDatePicker"
            placeholder="{{ 'arrival-date' | translate }}"
            [value]=""
            (change)="changeArrivalDate()"
            data-test="day-old-chick-item__arrival-date"
          />
          <mat-datepicker-toggle matIconSuffix [for]="arrivalDatePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #arrivalDatePicker></mat-datepicker>
          <mat-error *ngIf="form.controls.arrivalDate.invalid">
            {{ 'error-arrival-date' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'birth-date' | translate }}</mat-label>
          <input
            matInput
            formControlName="chickBirthDate"
            [matDatepicker]="chickBirthDatePicker"
            placeholder="{{ 'birth-date' | translate }}"
            [value]=""
            data-test="day-old-chick-item__chick-birth-date"
          />
          <mat-datepicker-toggle matIconSuffix [for]="chickBirthDatePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #chickBirthDatePicker></mat-datepicker>
          <mat-error *ngIf="form.controls.chickBirthDate.invalid">
            {{ 'error-chick-birth-date' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'barn' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            [compareWith]="compareBarns"
            formControlName="barn"
            data-test="day-old-chick-item__barn"
          >
            <mat-option *ngFor="let barn of barns$ | async" [value]="barn">
              {{ barn.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.barn.invalid">
            {{ 'error-barn-selected' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'breed' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            [compareWith]="compareBreeds"
            formControlName="breed"
            data-test="day-old-chick-item__breed"
          >
            <mat-option *ngFor="let breed of breeds$ | async" [value]="breed">
              {{ breed.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.breed.invalid">
            {{ 'error-breed' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'hatchery' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            [compareWith]="compareHatcheries"
            formControlName="hatchery"
            data-test="day-old-chick-item__hatchery"
          >
            <mat-option *ngFor="let hatchery of hatcheries$ | async" [value]="hatchery">
              {{ hatchery.name }} - {{ hatchery.address }} - {{ hatchery.city }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.hatchery.invalid">
            {{ 'error-hatchery' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'chicks-weight-in-grams' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            formControlName="chicksWeightInGrams"
            placeholder="{{ 'chicks-weight-in-grams' | translate }}"
            data-test="day-old-chick-item__chicks-weight-in-grams"
          />
          <span matTextSuffix>{{ 'grams' | translate | lowercase }}</span>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'parent-stock-identifier' | translate }}</mat-label>
          <input
            matInput
            formControlName="parentStockIdentifier"
            placeholder="{{ 'parent-stock-identifier' | translate }}"
            data-test="day-old-chick-item__parent-stock-identifier"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'chicks-parents-age-in-weeks' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            formControlName="chicksParentsAgeInWeeks"
            placeholder="{{ 'chicks-parents-age-in-weeks' | translate }}"
            data-test="day-old-chick-item__chicks-parents-age-in-weeks"
          />
          <span matTextSuffix>{{ 'weeks' | translate | lowercase }}</span>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'amount' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [enableStepArrows]="false"
            formControlName="amountOfChicks"
            placeholder="{{ 'amount' | translate }}"
            data-test="day-old-chick-item__amount-of-chicks"
          />
          <span matTextSuffix>{{ 'day-old-chicks' | translate | lowercase }}</span>
          <mat-error *ngIf="form.controls.amountOfChicks.errors?.required">
            {{ 'error-amount-of-chicks' | translate }}
          </mat-error>
          <mat-error *ngIf="form.controls.amountOfChicks.errors?.max">
            {{ 'error-amount-of-chicks-too-big' | translate }}
          </mat-error>
          <mat-error *ngIf="form.controls.amountOfChicks.errors?.minAmount">
            {{ 'error-amount-of-chicks-minimum' | translate }}
            {{ form.controls.amountOfChicks.errors.minAmount }}
          </mat-error>
        </mat-form-field>
        <mat-slide-toggle
          [hideIcon]="true"
          data-test="day-old-chick-item__toggleAmounts"
          color="primary"
          class="text--small spacing--margin-bottom"
          labelPosition="before"
          formControlName="amounts"
        >
          {{ 'enter-amounts' | translate }}
        </mat-slide-toggle>

        <div class="flex--column" *ngIf="form.controls.amounts.value">
          <app-cost-item
            [form]="form.controls.price"
            [amountOfChicks]="this.form.controls.amountOfChicks.value"
            [vatPercentage]="this.form.controls.vatPercentage.value"
            [currency]="cycle.currency"
            chickCostLabel="{{ 'chick-price' | translate }}"
          >
          </app-cost-item>

          <app-cost-item
            [form]="form.controls.discount"
            [amountOfChicks]="this.form.controls.amountOfChicks.value"
            [vatPercentage]="this.form.controls.vatPercentage.value"
            [currency]="cycle.currency"
            chickCostLabel="{{ 'discount-price' | translate }}"
          >
          </app-cost-item>

          <div class="arrival-notification">
            {{ 'arrival-notification-cycle-overview' | translate }}
          </div>

          <app-cost-item
            [form]="form.controls.vaccination"
            [amountOfChicks]="this.form.controls.amountOfChicks.value"
            [vatPercentage]="this.form.controls.vatPercentage.value"
            [currency]="cycle.currency"
            chickCostLabel="{{ 'vaccination-price' | translate }}"
          >
          </app-cost-item>

          <app-cost-item
            [form]="form.controls.diverse"
            [amountOfChicks]="this.form.controls.amountOfChicks.value"
            [vatPercentage]="this.form.controls.vatPercentage.value"
            [currency]="cycle.currency"
            chickCostLabel="{{ 'diverse-price' | translate }}"
          >
          </app-cost-item>

          <app-cost-total
            [currency]="cycle.currency"
            [form]="form.controls.calculatedAmounts"
            [priceAmount]="form.controls.price.controls.chicksTotalCost.value"
            [priceAmountIncludingVat]="
              form.controls.price.controls.chicksTotalCostIncludingVat.value
            "
            [vaccinationAmount]="form.controls.vaccination.controls.chicksTotalCost.value"
            [vaccinationAmountIncludingVat]="
              form.controls.vaccination.controls.chicksTotalCostIncludingVat.value
            "
            [discountAmount]="form.controls.discount.controls.chicksTotalCost.value"
            [discountAmountIncludingVat]="
              form.controls.discount.controls.chicksTotalCostIncludingVat.value
            "
            [diverseAmount]="form.controls.diverse.controls.chicksTotalCost.value"
            [diverseAmountIncludingVat]="
              form.controls.diverse.controls.chicksTotalCostIncludingVat.value
            "
          >
          </app-cost-total>

          <div class="arrival-notification">
            {{ 'arrival-notification-final-setup' | translate }}
          </div>
        </div>

        <mat-form-field
          class="flex__child--auto"
          [ngClass]="{ 'spacing--margin-top': form.controls.amounts.value === false }"
        >
          <mat-label>{{ 'invoice-date' | translate }}</mat-label>
          <input
            matInput
            formControlName="invoiceDate"
            [matDatepicker]="invoiceDatePicker"
            placeholder="{{ 'invoice-date' | translate }}"
            data-test="day-old-chick-item__invoice-date"
          />
          <mat-datepicker-toggle matIconSuffix [for]="invoiceDatePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #invoiceDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'invoice-number' | translate }}</mat-label>
          <input
            matInput
            formControlName="invoiceNumber"
            placeholder="{{ 'invoice-number' | translate }}"
            data-test="day-old-chick-item__invoice-number"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'vat-percentage' | translate }}</mat-label>
          <span matTextSuffix class="form-field-suffix">%</span>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            formControlName="vatPercentage"
            data-test="day-old-chick-item__vatPercentage"
          >
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let vatPercentage of vatPercentages" [value]="vatPercentage">
              {{ vatPercentage }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="mat-button-row spacing--margin-top">
          <button type="submit" mat-flat-button color="primary">
            {{ 'save' | translate }}
          </button>
        </div>
      </div>
    </form>
  </section>
</agr-page-detail>
